import { useEffect, useState } from 'react'
import { convertResponse, convertSubZoneResponse } from '../utils'
import { useDispatch, useSelector } from 'react-redux'
import { findNode } from 'tools/functions/Methods'
import { getAPI } from 'services/CRUDServices'
import { getUrls } from 'services/api.enums'
import { activeAddZone, clearGeoList } from 'redux/customGeo/customGeoReducer'
import { ActionSidebar } from 'redux/optime/optime'

export const useGetZone = () => {
  const { areaType } = useSelector((state: any) => state.customGeo)
  const { CurrentHub } = useSelector((state: any) => state.currentHubInfo)
  const userInfo = useSelector((state: any) => state.userInfo)
  const dispatch = useDispatch()
  const [polygons, setSelectedPolygons] = useState([])
  const [response, setResponse] = useState()

  const getZoneInfo = async (areaTypeProps?: any) => {
   
    const hubId = findNode({ children: userInfo.hublist }, CurrentHub.value)?.id
    if (!hubId) return

    try {
      const res = await getAPI(
        `${getUrls.countryDevisionFindbyhub}?code=${CurrentHub.value}&hubid=${hubId}`
      )
      dispatch(clearGeoList())
      const zoneRes = await getAPI(`${getUrls.findByRegion}/${hubId}`)

      const main = [convertResponse(zoneRes.data.payload)]

      if (res.data.payload.length !== 0) {
        let sub = []
        if (areaTypeProps || areaType) {
          sub = res.data.payload
            .map((item) => convertSubZoneResponse(item))
            .filter(
              (area) => area.countryType.id === (areaTypeProps || areaType)
            )
        } else {
          sub = res.data.payload.map((item) => convertSubZoneResponse(item))
        }

        setSelectedPolygons([...main, ...sub])
      } else {
        setSelectedPolygons(main)
      }
      dispatch(activeAddZone(false))
      setResponse(res.data.payload)
    } catch (error) {
      console.error('Failed to fetch zone data', error)
    }
  }

  useEffect(() => {
    if (!CurrentHub?.value || !userInfo?.hublist) return
    getZoneInfo()
  }, [CurrentHub, userInfo])

  return {
    polygons,
    setSelectedPolygons,
    getZoneInfo,
    response,
  }
}


